"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = stringSearch;
exports.isOdd = isOdd;
exports.stringSearchArray = stringSearchArray;
function stringSearch(matrix, target) {
  if (matrix === null || matrix[0] === null || matrix.length === 0 || matrix[0].length === 0) {
    return false;
  }
  var rows = matrix.length;
  for (var x = 0; x < rows; x += 1) {
    var cols = matrix[x].length;
    var y = cols - 1;
    while (y) {
      if (matrix[x][y].startsWith(target)) {
        return true;
      }
      y -= 1;
    }
  }
  return false;
}
function stringSearchArray(matrix, arrayTarget) {
  var result = false;
  arrayTarget.forEach(function (elem) {
    result = stringSearch(matrix, elem) || result;
  });
  return result;
}
function isOdd(matrix) {
  return Math.abs(matrix % 2) === 1;
}